module.exports = __webpack_public_path__ + "img/bars_graph_icon.9b0cc83a.svg";